( function( $ ) {
    'use strict';

    $( function() {
        const bannerCarousel = $( '.js-banner-carousel' );

	    const updateLink = ( index ) => {
		    let $sourceButtons = $( '.js-banner-carousel-link-source' );
		    let $targetButton = $( '.js-banner-carousel-link-target' );

		    if ( index < 0 ) {
		    	index = 0;
		    }

		    $targetButton.attr( 'href', $sourceButtons[index] );

		    if ( '#' !== $targetButton.attr( 'href' ) ) {
			    $targetButton.addClass( 'is-visible' );
		    }
	    };

	    bannerCarousel.on( 'initialize.owl.carousel, changed.owl.carousel', function( event ) {
		    updateLink( event.page.index );

	    } );

        bannerCarousel.owlCarousel( {
	        items: 1,
	        dots: true,
	        dotsContainer: '.js-banner-carousel-dots',
	        autoplay: true,
	        autoplayTimeout: 4000,
	        loop: true,
	        animateOut: 'fadeOut',

        } );

    } );
} )( jQuery );
